import instance from "../store/actions/instance";

export const STOREFRONT_V2_TELEMETRY = Object.freeze({
  PRICE_QUOTE_MISMATCH: "storefront_v2_price_quote_mismatch",
  CART_LINE_REMOVED: "storefront_v2_cart_line_removed",
  CART_LINE_RESTORED: "storefront_v2_cart_line_restored",
  CHECKOUT_ABANDONED: "storefront_v2_checkout_abandoned",
  PLACE_ORDER_FAILED: "storefront_v2_place_order_failed",
  PAYMENT_RECOVERED: "storefront_v2_payment_recovered",
  POLLING_TIMED_OUT: "storefront_v2_polling_timed_out",
});

const ALLOWED_SOURCES = Object.freeze({
  [STOREFRONT_V2_TELEMETRY.PRICE_QUOTE_MISMATCH]: Object.freeze([
    "checkout_quote",
    "promise_place",
  ]),
  [STOREFRONT_V2_TELEMETRY.CART_LINE_REMOVED]: Object.freeze([
    "context_change",
  ]),
  [STOREFRONT_V2_TELEMETRY.CART_LINE_RESTORED]: Object.freeze([
    "cart_restore",
  ]),
  [STOREFRONT_V2_TELEMETRY.CHECKOUT_ABANDONED]: Object.freeze([
    "checkout_contact",
    "checkout_fulfillment",
    "checkout_extras",
    "checkout_payment",
  ]),
  [STOREFRONT_V2_TELEMETRY.PLACE_ORDER_FAILED]: Object.freeze([
    "promise_place",
  ]),
  [STOREFRONT_V2_TELEMETRY.PAYMENT_RECOVERED]: Object.freeze([
    "payment_status",
  ]),
  [STOREFRONT_V2_TELEMETRY.POLLING_TIMED_OUT]: Object.freeze([
    "payment_status",
  ]),
});

export const isAllowedStorefrontV2Telemetry = (type, source) =>
  Array.isArray(ALLOWED_SOURCES[type]) && ALLOWED_SOURCES[type].includes(source);

// This deliberately accepts no metadata object: the existing glance endpoint
// only needs an allowlisted aggregate bucket, so shopper/order/cart data can
// never be added accidentally. Analytics must never interrupt checkout.
export const recordStorefrontV2Telemetry = (
  type,
  source,
  post = (path, body) => instance.post(path, body),
) => {
  if (!isAllowedStorefrontV2Telemetry(type, source)) return false;
  try {
    const request = post("/analytics/glance/", { type, source });
    if (request && typeof request.catch === "function") request.catch(() => {});
    return true;
  } catch (error) {
    return false;
  }
};

export const getCheckoutAbandonmentSource = (section) =>
  ({
    contact: "checkout_contact",
    fulfillment: "checkout_fulfillment",
    extras: "checkout_extras",
    payment: "checkout_payment",
  })[section] || "checkout_contact";
